var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"btn btn-danger",on:{"click":_vm.dismissUser}},[_vm._v("\n    Zwolnij pracownika\n")])}
var staticRenderFns = []

export { render, staticRenderFns }